import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type ArrowUpwardProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function ArrowUpward(props: ArrowUpwardProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="ArrowUpwardIcon"
      style={style}
    >
      <path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z" />
    </svg>
  )
}
